import { render, staticRenderFns } from "./LKBanners.vue?vue&type=template&id=68b7d9be&"
import script from "./LKBanners.vue?vue&type=script&lang=js&"
export * from "./LKBanners.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/transitions/transition-slide.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./LKBanners.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VExpandTransition})
